type RecordedCoupon = {
  discount?: number | string | null;
  totalTicketDiscount?: number | null;
  applied?: boolean | null;
};

/**
 * What a charge's coupon took off, in cents, or null when the record holds no figure and the
 * caller falls back to the coupon's face value. Ticket shares live apart from `discount`.
 */
export const getRecordedCouponDiscount = (
  coupon: RecordedCoupon | null | undefined,
): number | null => {
  if (!coupon) return null;
  if (coupon.applied === false) return 0;
  const total = (Number(coupon.discount) || 0) + (Number(coupon.totalTicketDiscount) || 0);
  return total > 0 ? total : null;
};
